import { Injectable } from '@angular/core';
import { AlertController, NavController } from '@ionic/angular';
import { GetAssetsFromDatabaseService } from './get-assets-from-database.service';

@Injectable({
    providedIn: 'root'
})
export class ProjectHeatmapService {

    constructor(
        public getAssetsFromDb: GetAssetsFromDatabaseService
    ) {
    }

    async GetAssetsInScene(sceneId) {
        return await this.getAssetsFromDb.getAssetsWithSceneIds(sceneId);
    }
}